<template>
  <el-card class="endCondition-effect" :body-style="{padding: '0 10px', width: '100%'}">
    <el-form class="form">
      <el-form-item
        v-if="!hasActiveGrades"
        class="form-item"
        label="Outcome"
      >
        <el-switch
          :value="state.effect.value"
          on-text="Win the scenario"
          off-text="Lose the scenario"
          on-color="#13ce66"
          off-color="#ff4949"
          :width="150"
          :disabled="readonly"
          class="outcome-switch"
          @input="updateEffectValue"
        />
      </el-form-item>
      <el-form-item
        v-if="hasActiveGrades"
        class="form-item"
        label="Outcome determined by grading"
      />
    </el-form>
  </el-card>
</template>

<script>
import isArray from 'lodash/isArray';

export default {
  name: 'end-condition-effect',
  components: {},
  props: [
    'states',
    'readonly',
    'emitter',
    'caseLogicDescription',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        effect: {
          value: false,
        },
      },
      value: 0,
    };
  },
  computed: {
    hasRubricGrades() {
      let result = false;
      const grading = this.emitter.caseConf.grading;
      if (grading) {
        for (const gradingItems of Object.values(grading)) {
          if (isArray(gradingItems) && gradingItems.find(item => item.grade !== 'NEUTRAL')) {
            result = true;
            break;
          }
        }
      }
      return result;
    },
    hasGradingEffects() {
      let result = false;
      const { caseLogicDescription } = this.emitter.caseConf;
      const nodes = caseLogicDescription ? caseLogicDescription.nodes : null;
      if (nodes) {
        for (const nodeKey of Object.keys(nodes)) {
          const node = nodes[nodeKey];
          if (node.name === 'Effect' && node.data.effect && node.data.effect.type === 'GRADING') {
            result = true;
            break;
          }
        }
      }
      return result;
    },
    hasActiveGrades() {
      return this.hasRubricGrades || this.hasGradingEffects;
    }
  },
  mounted() {
    this.state.effect = this.getData(this.ikey) || { value: false };
    this.update();
  },
  methods: {
    updateEffectValue(value) {
      this.state.effect.value = value;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'GAME_END',
        value: this.state.effect.value,
      });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.endCondition-effect,
.endCondition-effect .form .form-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.form-item {
  margin-bottom: 0;
}
</style>
